// extracted by mini-css-extract-plugin
export default {"box":"style_box__RB3-Q","titleBlock":"style_titleBlock__BbZ65","menuPart":"style_menuPart__iay4w"};